import React, { useState, useEffect } from "react";
import {
  convertTo12Hr,
  getAmPm,
  isInTargetWindow,
  isBeforeTargetWindow,
  isPastTargetWindow,
  isFresh
} from "./functions";

interface TargetTimeProps {
  startHour: number;
  endHour: number;
  sentDate: number;
  alreadyMade: number;
  targetFresh: number;
}

const TargetTime: React.FC<TargetTimeProps> = ({
  startHour,
  endHour,
  sentDate,
  alreadyMade,
  targetFresh
}) => {
  const [missing, setMissing] = useState(false);
  const [before, setBefore] = useState(false);
  const [past, setPast] = useState(false);

  useEffect(() => {
    const checkStatus = () => {
      setMissing(
        (isInTargetWindow(startHour, endHour) && alreadyMade === 0) ||
          (isInTargetWindow(startHour, endHour) &&
            alreadyMade > 0 &&
            !isFresh(targetFresh, sentDate))
      );
      setPast(isPastTargetWindow(endHour));
      setBefore(isBeforeTargetWindow(startHour));
    };
    checkStatus();

    const checkStatusTimer = setInterval(() => {
      checkStatus();
    }, 60000);

    return () => clearInterval(checkStatusTimer);
  }, [sentDate]);

  return (
    <td
      className={`centered jr-target-window${
        missing ? " target--missing" : ""
      }${past ? " target--past" : ""}${before ? " target--before" : ""}`}
    >
      <span className="target-times">
        {convertTo12Hr(startHour)}
        <small>{getAmPm(startHour)}</small> {startHour && endHour ? "-" : null}{" "}
        {convertTo12Hr(endHour)}
        <small>{getAmPm(endHour)}</small>
      </span>
    </td>
  );
};

export default TargetTime;
